import { useState } from 'react';

import * as S from './ScrollButton.styles';

export function ScrollButton(): React.ReactElement {
  const [isVisible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  window.addEventListener('scroll', toggleVisible);

  return (
    <S.Container>
      {isVisible ? (
        <S.Btn
          onClick={() => scrollToTop()}
          iconLeft="FiChevronUp"
          motive="transparentPrimary"
        />
      ) : undefined}
    </S.Container>
  );
}
